import React from "react";
import classNames from 'classnames';
import next from '../../../assets/icons/next.png';

export const InputSubmit = ({
  buttonLabel,
  buttonStyle,
  disabled = false,
  buttonType = 'submit',
  loginText = 'Log In',
  buttonAction = () => { },
  containerStyle
}) => {
  return (


    <button
      disabled={disabled}
      type={buttonType}
      onClick={(e) => { buttonAction() }}
      className={classNames([
        "btn btn-md btn-primary",
        buttonStyle
      ])}>
      {buttonLabel}{" "}
      {buttonLabel === loginText && <i className="ml-2">
        <img src={next} alt="" width="21" />
      </i>}
    </button>


  );
};
